<template>
  <div class="footer">
    <div style="width:1500px;margin: 0 auto;">
      <div class="friLink">
        <div>
          <p style="font-size:16px;color:#fff;">友情链接</p>
          <p style="text-align:center;">Links</p>
        </div>
        <div>
          <p><a target="_blank" href="http://edu.gd.gov.cn/">广东省教育厅</a></p>
          <p><a target="_blank" href="https://jstsgc.gdedu.gov.cn/info2/gateway/route/goIndex.action">广东省中小学教师信息技术应用能力提升工程2.0</a></p>
          <p><a target="_blank" href="http://www.southteacher.com/">南方教师在线</a></p>
        </div>
        <div>
           <p><a target="_blank" href="http://jyj.gz.gov.cn">广州市教育局</a></p>
          <p><a target="_blank" href="http://tsgc.gzedu.com/index/GZTSGC_SY.html">广州市中小学教师信息技术应用能力提升工程</a></p> 
          <p><a target="_blank" href="http://league.gzteacher.com/">广州市市级教师发展中心联盟</a></p> 
        </div>
      </div>
      <div style="font-size:12px;">© 2022  广州市广播电视大学版权所有 <br> 广东易教优培教育科技有限公司技术支持</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data () {
    return {
      footerInfo: ''
    }
  },
  created () {
    // this.footerInfo = this.appUtils.getAppInfo().loginFooter;
    // console.log(this.footerInfo);
  }
}
</script>

<style lang="less" scoped>
.footer {
  padding: 20px 0;
  height: 177px;
  background: #212E37;
  border: 1px solid #707070;
  color: #CCCCCC;
  .friLink{
    padding: 20px 200px;
    text-align: start;
    border-bottom: 1px solid #4D616E;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 14px;
    a{
      color: #ccc;
      &:hover{
        color: #1890FF;
      }
    }
  }
}
</style>
